export const EMPLOYEE = 'Employee';
export const FREELANCER = 'Freelancer';
export const THIRD_PARTY = '3rdparty';
export const NOT_SET = 'NotSet';
